import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { Search } from "lucide-react";

const Header = () => {
  return (
    <header className="lg:shadow-xl md:shadow-xl shadow-lg z-40 w-full bg-white">
      <nav className="py-5 lg:px-40 md:px-10 px-4 z-30">
        <div className="flex justify-between items-center">
          <Link href="">
            <Image
              alt="logo"
              src="/Logo.svg"
              width={245}
              height={53}
              className="ml-[35px]"
            />
          </Link>

          <div className="hidden lg:flex md:flex">
            <Link
              href="https://tipanonymous.com/"
              target="_blank"
              className="px-8 text-slate"
            >
              Contact us
            </Link>
            <Link href="/" className="text-slate">
              Sign in
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};
export default Header;
